import ImageFlow from '@/modules/adjusterReportModules/IncidentParticipants/pages/common/imageFlow/ImageFlow';
import { ADJUSTER_REPORT_BODY_DAMAGE_LINKS } from '@/modules/adjusterReportModules/adjusterReport/links/bodyDamage/bodyDamageLinks';
import { useNavigate, useParams } from 'react-router-dom';

const BodyImageFlow = () => {
  const navigate = useNavigate();
  const params = useParams();

  const navigateBack = () => {
    navigate(
      ADJUSTER_REPORT_BODY_DAMAGE_LINKS.BODY_DAMAGE_IMAGES({
        id: params?.id!,
      }).ADJUSTER_VEHICLE.damagedPoints,
      {
        replace: true,
      },
    );
  };

  const finishFlow = () => {
    navigate(
      ADJUSTER_REPORT_BODY_DAMAGE_LINKS.BODY_DAMAGE_IMAGES({
        id: params.id!,
      }).ADJUSTER_VEHICLE.previewImages,
      { replace: true },
    );
  };

  return (
    <ImageFlow
      finishFlow={finishFlow}
      navigateBack={navigateBack}
      filetype="body"
    />
  );
};
export default BodyImageFlow;
